import { LinkProps, Link as ReactRouterLink } from 'react-router';

import { cn } from '../lib';

export const Link = ({ className, children, ...props }: LinkProps) => {
  return (
    <ReactRouterLink
      viewTransition
      className={cn(
        'pointer-events-auto text-sm font-medium !text-primary transition-all duration-200 ease-in-out hover:!text-primary-hover active:!text-primary-active',
        className,
      )}
      {...props}
    >
      {children}
    </ReactRouterLink>
  );
};
